<template>
    <div class="turnover-card mt-4 mx-4">
        <div class="turnover-row">
            <span class="label">{{ $t('setting.current_turnover_amount') }}</span>
            <span class="value">
                {{ Number($store.state.authUser.turn_over_amount).toLocaleString() }}
            </span>
        </div>

        <p
            class="turnover-hint"
            v-html="$t('setting.turnover_hint')"
        >
        </p>
    </div>
</template>

<script>
export default {
    computed: {
        turnoverPercent() {
            const required = this.$store.state.authUser.required_turnover || 1
            const current = this.$store.state.authUser.turn_over_amount || 0

            return Math.min((current / required) * 100, 100)
        }
    }
};
</script>

<style scoped>
.turnover-card {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    padding: 10px 12px;
}

.turnover-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.turnover-row .label {
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
}

.turnover-row .value {
    font-size: 18px;
    font-weight: 600;
    color: #4ade80;
}

.turnover-hint {
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    opacity: 0.6;
    margin-top: 6px;
    margin-bottom: 0;
    line-height: 1.4;
}
</style>
